export const START_CONVERSATION_CTA_COLOR = '#00CAF0';
